import { useState } from 'react'
import { T, fonts } from '../../styles/theme'
import { crearUsuario, generarPasswordSegura } from '../../services/adminService'
import { useAuth } from '../../hooks/useAuth'
import { QRCodeSVG } from 'qrcode.react'

export default function GestionUsuarios({ onBack, esAdmin }) {
  const { user } = useAuth()
  const [tab, setTab] = useState('paciente')
  const [form, setForm] = useState({
    email: '', nombre: '', altura_cm: '',
    fecha_nacimiento: '', sexo: 'F', password: '',
  })
  const [loading, setLoading] = useState(false)
  const [resultado, setResultado] = useState(null)
  const [error, setError] = useState('')

  function resetForm() {
    setForm({ email: '', nombre: '', altura_cm: '', fecha_nacimiento: '', sexo: 'F', password: '' })
    setError('')
  }

  async function handleCrear() {
    if (!form.email || !form.nombre) {
      setError('Email y nombre son obligatorios')
      return
    }
    setLoading(true)
    setError('')
    setResultado(null)
    try {
      const password = form.password || generarPasswordSegura()
      const res = await crearUsuario({
        email: form.email,
        nombre: form.nombre,
        rol: tab,
        altura_cm: form.altura_cm || null,
        fecha_nacimiento: form.fecha_nacimiento || null,
        sexo: form.sexo || null,
        profesional_id: user?.id,
        password,
      })
      setResultado({
        email: form.email,
        nombre: form.nombre,
        loginUrl: res.loginUrl,
        password,
      })
      resetForm()
    } catch (e) {
      setError(e.message)
    }
    setLoading(false)
  }

  const inp = (label, key, placeholder, type = 'text') => (
    <div style={{ marginBottom: 14 }}>
      <div style={{ fontSize: 13, color: T.muted, marginBottom: 6 }}>{label}</div>
      <input
        type={type}
        placeholder={placeholder}
        value={form[key]}
        onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))}
        style={{ width: '100%', background: T.bg, border: `1px solid ${T.cardB}`, borderRadius: 12, padding: '12px 16px', fontSize: 15, fontFamily: 'DM Sans', outline: 'none', color: T.text }}
      />
    </div>
  )

  return (
    <>
      <style>{`${fonts} * { box-sizing: border-box; margin: 0; padding: 0; } body { background: ${T.bg}; font-family: 'DM Sans', sans-serif; }`}</style>
      <div style={{ background: T.bg, minHeight: '100vh', width: '100%' }}>
      <div style={{ maxWidth: 390, margin: '0 auto', minHeight: '100vh', background: T.bg, paddingBottom: 40 }}>

        <div style={{ padding: '52px 20px 12px', display: 'flex', alignItems: 'center', gap: 12 }}>
          <button onClick={onBack} style={{ width: 36, height: 36, borderRadius: 10, background: T.card, border: `1px solid ${T.cardB}`, color: T.text, cursor: 'pointer', fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>←</button>
          <div>
            <div style={{ fontSize: 18, fontWeight: 700 }}>Nuevo usuario</div>
            <div style={{ fontSize: 12, color: T.muted }}>Crear acceso a NutriControl</div>
          </div>
        </div>

        {/* Selector rol */}
        <div style={{ display: 'flex', gap: 8, margin: '0 16px 20px' }}>
          {[['paciente', '👤 Paciente'], ...(esAdmin ? [['profesional', '🩺 Profesional']] : [])].map(([k, l]) => (
            <button key={k} onClick={() => { setTab(k); resetForm() }} style={{
              flex: 1, padding: '12px 0', borderRadius: 12,
              border: `1px solid ${tab === k ? T.accent : T.cardB}`,
              background: tab === k ? T.accentSoft : T.card,
              color: tab === k ? T.accent : T.muted,
              fontSize: 14, cursor: 'pointer', fontWeight: 600
            }}>{l}</button>
          ))}
        </div>

        <div style={{ margin: '0 16px' }}>
          {!resultado && <>
            {inp('Nombre completo', 'nombre', 'ej: María García')}
            {inp('Email', 'email', 'ej: maria@email.com', 'email')}
            {inp('Contraseña temporal', 'password', 'ej: Nutri2026')}

            {tab === 'paciente' && <>
              <div style={{ marginBottom: 14 }}>
                <div style={{ fontSize: 13, color: T.muted, marginBottom: 8 }}>Sexo</div>
                <div style={{ display: 'flex', gap: 8 }}>
                  {[['F', 'Mujer'], ['M', 'Hombre']].map(([k, l]) => (
                    <button key={k} onClick={() => setForm(f => ({ ...f, sexo: k }))} style={{
                      flex: 1, padding: '10px 0', borderRadius: 10,
                      border: `1px solid ${form.sexo === k ? T.accent : T.cardB}`,
                      background: form.sexo === k ? T.accentSoft : T.bg,
                      color: form.sexo === k ? T.accent : T.muted,
                      fontSize: 13, cursor: 'pointer', fontWeight: 600
                    }}>{l}</button>
                  ))}
                </div>
              </div>
              {inp('Fecha de nacimiento', 'fecha_nacimiento', '', 'date')}
              {inp('Altura (cm)', 'altura_cm', 'ej: 165', 'number')}
            </>}

            {error && (
              <div style={{ background: 'rgba(248,113,113,0.12)', border: `1px solid ${T.danger}`, borderRadius: 10, padding: '10px 14px', fontSize: 13, color: T.danger, marginBottom: 16 }}>
                {error}
              </div>
            )}

            <button onClick={handleCrear} disabled={loading} style={{
              width: '100%', padding: 14, borderRadius: 14,
              background: loading ? T.cardB : T.accent,
              color: loading ? T.muted : '#000',
              fontSize: 15, fontWeight: 700, border: 'none',
              cursor: loading ? 'not-allowed' : 'pointer'
            }}>
              {loading ? 'Creando usuario...' : `Crear ${tab}`}
            </button>
          </>}

          {resultado && (
            <div style={{ background: T.accentSoft, border: `1px solid ${T.accent}`, borderRadius: 16, padding: 20, marginBottom: 16 }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: T.accent, marginBottom: 4 }}>
                ✅ Usuario creado correctamente
              </div>
              <div style={{ fontSize: 13, color: T.sub, marginBottom: 16 }}>
                <strong>{resultado.nombre}</strong> puede escanear el QR o usar las credenciales
              </div>

              {/* Credenciales */}
              <div style={{ background: T.card, border: `1px solid ${T.accent}`, borderRadius: 10, padding: '14px 16px', marginBottom: 12 }}>
  <div style={{ fontSize: 11, fontWeight: 600, color: T.accent, marginBottom: 10, letterSpacing: 1, textTransform: 'uppercase' }}>
    Credenciales de acceso
  </div>
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
    <span style={{ fontSize: 13, color: T.muted }}>📧 Email</span>
    <span style={{ fontSize: 13, fontWeight: 700, color: T.text }}>{resultado.email}</span>
  </div>
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: 8, borderTop: `1px solid ${T.cardB}` }}>
    <span style={{ fontSize: 13, color: T.muted }}>🔑 Contraseña</span>
    <span style={{ fontSize: 15, fontWeight: 700, color: T.accent, fontFamily: 'DM Mono' }}>{resultado.password}</span>
  </div>
  <div style={{ fontSize: 11, color: T.muted, marginTop: 10, lineHeight: 1.5 }}>
    Comunica estas credenciales al paciente de forma segura
  </div>
</div>
              

              {resultado.loginUrl ? (
                <>
                  <div style={{ background: '#fff', borderRadius: 12, padding: 16, display: 'flex', justifyContent: 'center', marginBottom: 12 }}>
                    <QRCodeSVG
                      value={resultado.loginUrl}
                      size={180}
                      bgColor="#ffffff"
                      fgColor="#0F1117"
                      level="M"
                    />
                  </div>
                  <div style={{ fontSize: 11, color: T.muted, textAlign: 'center', marginBottom: 12, lineHeight: 1.5 }}>
                    El QR caduca en 24 horas.<br />
                    El paciente lo escanea con la cámara del móvil para entrar directamente.
                  </div>
                  <button
                    onClick={() => navigator.clipboard.writeText(resultado.loginUrl)}
                    style={{ width: '100%', padding: '10px 0', borderRadius: 10, background: 'transparent', border: `1px solid ${T.cardB}`, color: T.muted, fontSize: 13, cursor: 'pointer' }}
                  >
                    📋 Copiar enlace
                  </button>
                </>
              ) : (
                <div style={{ fontSize: 13, color: T.muted }}>
                  El usuario puede acceder con email y contraseña.
                </div>
              )}

              <button
                onClick={() => setResultado(null)}
                style={{ width: '100%', marginTop: 10, padding: '10px 0', borderRadius: 10, background: T.accentSoft, border: `1px solid ${T.accent}`, color: T.accent, fontSize: 13, cursor: 'pointer', fontWeight: 600 }}
              >
                Crear otro usuario
              </button>
            </div>
          )}
        </div>
      </div>
      </div>
    </>
  )
}